import { FormContext, FormControl, FormGroup, FormLabel, SelectOption, OverlayTrigger } from '@hai/ui-react';
import React from 'react';
import { generateDataAuto } from 'src/js/util/automation';
import { FormChangeHandler } from 'src/js/util/global-type';

export type SelectOption = {
  value: number | string;
  label?: string;
  description?: string;
  disabled?: boolean; // to show grayed out
  when?: boolean; // to display or not
};

export type SelectOptions = SelectOption[];

interface Props {
  id?: string;
  title?: string;
  name?: string;
  mask?: boolean;
  defaultSelect?: any;
  defaultValue?: any;
  disabled?: boolean;
  disableSingleOption?: boolean;
  hint?: string;
  onChange?: FormChangeHandler;
  options: SelectOptions;
  className?: string;
  direction?: string;
  tooltip?: string | React.ReactNode;
}

export const FormSelect: React.FunctionComponent<Props> = ({
  title,
  name,
  mask,
  defaultSelect,
  defaultValue,
  disabled,
  disableSingleOption,
  hint,
  onChange,
  options,
  className,
  direction = 'down',
  tooltip,
  ...rest
}) => {
  return (
    <FormContext.Consumer>
      {(formContext: any) => {
        const meta = formContext?.getFieldMeta(name);
        const formikValue = meta?.touched ? meta.value : meta?.initialValue;
        if (options === undefined) {
          /* eslint-disable-next-line no-console */
          console.error('FormSelect has no options', name);
          return undefined;
        }
        const displayedOptions = options.filter((o) => o != null && (o.when === undefined || o.when === true));
        // At the moment we let the page handle this situation but if we would want to fix them all here it could be something like that
        // const existingInOptions = displayedOptions.find((option) => option.value == formikValue);
        // if (existingInOptions === undefined) {
        // console.warn('Selected option does not exists in dropdown', name)
        // set first option
        //}

        /* DEBUG
        if (name === "packetTime") {
          console.log('hint', hint)
          console.log('displayedOptions', displayedOptions)
          console.log('defaultSelect', defaultSelect)
          console.log('defaultValue', defaultValue)
          console.log('defaultValue set', defaultValue ?? formikValue)
          console.log('formikValue', formikValue)
        }*/

        return (
          <FormGroup className={className} data-auto={generateDataAuto('form_group', name)}>
            <FormLabel>{title}</FormLabel>
            <FormControl
              as="select"
              key={`formselect-${name}`}
              name={name}
              useFsMask={mask}
              disabled={disabled}
              disableSingleOption={disableSingleOption}
              defaultSelect={defaultSelect}
              defaultValue={defaultValue ?? formikValue}
              hintText={hint}
              showHint={true}
              onChange={onChange}
              selectMenuDirection={direction as any}
              {...rest}
            >
              {displayedOptions.map((option, _index) => (
                <SelectOption
                  key={`mk-${option.label}-${option?.value}`}
                  value={typeof option?.value === 'number' ? option?.value : option?.value}
                  description={option?.description}
                  disabled={option?.disabled}
                >
                  {option?.label}
                </SelectOption>
              ))}
            </FormControl>
            {tooltip != null && (
              <div className="mk-field-tooltip">
                <OverlayTrigger popoverContent={tooltip} placement="top">
                  <div className="filler">{tooltip}</div>
                </OverlayTrigger>
              </div>
            )}
          </FormGroup>
        );
      }}
    </FormContext.Consumer>
  );
};
